const updates = [
  {
    date: '2026-07-30',
    time: '14:28',
    title: '暑期档票房大战进入白热化阶段，多部大片正面交锋',
    tag: '影视',
  },
  {
    date: '2026-07-30',
    time: '11:15',
    title: '热门综艺录制路透曝光，新一季阵容引发广泛讨论',
    tag: '综艺',
  },
  {
    date: '2026-07-30',
    time: '09:42',
    title: '当红小生新剧定档，粉丝期待值拉满',
    tag: '明星',
  },
  {
    date: '2026-07-29',
    time: '21:30',
    title: '年度音乐盛典提名名单正式公布，多个奖项竞争激烈',
    tag: '音乐',
  },
  {
    date: '2026-07-29',
    time: '17:55',
    title: '知名导演新作杀青，主演阵容豪华引期待',
    tag: '影视',
  },
  {
    date: '2026-07-29',
    time: '14:20',
    title: '时尚周街拍合集：明星私服穿搭大盘点',
    tag: '时尚',
  },
  {
    date: '2026-07-29',
    time: '10:08',
    title: '热门网剧续集官宣原班人马回归，评论区炸了',
    tag: '剧集',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              实时追踪娱乐圈最前沿的动态与快讯
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-300/60"></div>
            <div className="space-y-0">
              {updates.map((item, index) => (
                <div key={index} className="relative flex items-start gap-4 md:gap-6 pb-6 last:pb-0 pl-10 md:pl-12">
                  <div className="absolute left-[9px] md:left-[11px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 cursor-pointer transition-all duration-200 hover:scale-[1.01] border border-background-200/60">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className="text-xs text-foreground-500 whitespace-nowrap">
                        {item.date} {item.time}
                      </span>
                      <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}